export enum SectionType {
    Address = 0,
    Shipping = 1,
    Payment = 2,
    Options = 3,
}

export enum ShippingType {
    None = '',
    Basic = 'basic',
    Saturday = 'saturday',
    Evening = 'evening',
}

export enum SyncServerSource {
    SaveVoucher = 'save-voucher',
}
